export const SAMPLE_CREATE_ORDER_REQUEST = {
  marketplaceId: "A1F83G8C2ARO7P",
  customer: {
    customerId: "A2VJ3P2EYVSXS8",
    addressId: "2OLX2CJLM4T7R3VKMSJYG12SXSVYE2P3JA2VJ3P2EYVSXS8PXTQ2EIA2OXA4X4OZ",
    paymentInstruments: [
      {
        paymentType: "CREDIT_CARD",
        paymentInstrumentId: "0h_TE_CUS_c5be93d0-5f0d-4968-9f9c-64352901ed85",
      },
    ],
  },
  orderItems: [
    {
      merchantId: "A3S1UW2Y55RLW7",
      asin: "BT6TSFMCDZ",
      sku: "QS-49OR-OO87",
      quantity: 1,
    },
  ],
  abGroupId: "A1N782TMJPH34H",
};

export const ENVS = {
  BETA: "beta",
  PROD: "prod",
};

export const ACCOUNTING_MONITOR_GROUP = "iba-core-dev";
